import { StatsRepository } from "../../../../data/repository/stats/StatsRepository";
import { ResponseState, State } from "../../../model/ResponseState";
import { QuestionAnswerCount } from "../../../model/Stats";

export interface GetQuestionsAnswersStatsUseCase {
  invoke: () => Promise<ResponseState<QuestionAnswerCount>>;
}

export class GetQuestionsAnswersStatsUseCaseImpl
  implements GetQuestionsAnswersStatsUseCase
{
  private statsRepository: StatsRepository;

  constructor(statsRepository: StatsRepository) {
    this.statsRepository = statsRepository;
  }

  async invoke(
    startDate?: string,
    endDate?: string
  ): Promise<ResponseState<QuestionAnswerCount>> {
    try {
      let response = await this.statsRepository.getQuestionsAndAnswersStats();
      if (response.isSuccessful) {
        return {
          responseState: State.Success,
          data: response.body!,
        };
      }
      return { responseState: State.Fail, error: response.errorBody! };
    } catch (error) {
      return {
        responseState: State.Error,
        error: { message: String(error), statusCode: 500 },
      };
    }
  }
}
